/**
 * KAN-905 (решение владельца): доска и таблица CRM за период сходятся с "Лидами по дням".
 * Флаг "Только новые лиды" (один на доску и таблицу, по умолчанию включён):
 * при заданном периоде лиды отбираются по дню появления (первого сообщения клиента),
 * выключен - доска по последней активности, таблица: новые лиды и взятые в работу
 * за период (KAN-973, раньше только по дню взятия).
 * При "Всё время" переключатель недоступен. Выбор запоминается в localStorage.
 * Параметры запросов собирает lib/newLeadsOnly.
 * KAN-910: флаг в адресе ?new=1|0 (useUrlFlag); без параметра - запомненный выбор
 * (localStorage) или включён, и он сразу пишется в адрес.
 */
import type { CrmRange } from '@/lib/crmTable';
import { useUrlFlag } from './useUrlState';

export const NEW_LEADS_STORAGE_KEY = 'crm:newLeadsOnly';
/** KAN-910: параметр адреса "Только новые лиды". */
export const NEW_LEADS_PARAM = 'new';

export interface NewLeadsOnlyState {
  newLeadsOnly: boolean;
  /** false при "Всё время": переключатель неактивен. */
  available: boolean;
  toggle: () => void;
}

export function useNewLeadsOnly(range: CrmRange | null): NewLeadsOnlyState {
  const [newLeadsOnly, toggle] = useUrlFlag(NEW_LEADS_PARAM, NEW_LEADS_STORAGE_KEY, true);
  return { newLeadsOnly, available: range !== null, toggle };
}
